export const BASE_URL = "https://ca08-196-61-44-226.ngrok-free.app/";
// export const BASE_URL = process.env.REACT_APP_BASE_URL;
